import { debounce } from "@/src/utils/utils";
import { useEffect, useRef, useState } from "react";
import { IoSearch } from "react-icons/io5";
import { AiDescription } from "../app/aiTasks/aiDescription";

export default function SearchBar({
  autoFocus,
  value,
  placeholder,
  onChange,
  onEnter,
}: {
  autoFocus?: boolean;
  value?: string | null;
  placeholder?: string;
  onChange?: (newValue: string) => void;
  onEnter?: (e: any, value: string) => void;
}) {
  const searchRef = useRef<
    HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement | null
  >(null);

  const [localValue, setLocalValue] = useState(value || "");

  useEffect(() => {
    if (autoFocus) {
      searchRef.current?.focus();
    }
  }, []);

  return (
    <AiDescription
      item={{
        title: "Search",
        type: "searchBar",
        ref: searchRef,
        value,
        placeholder,
        onChange,
        onEnter,
      }}
    >
      <div className="searchBar">
        <IoSearch size={20} color="RGBA(0,0,0,0.4)" />
        <input
          ref={searchRef as any}
          type="text"
          value={localValue || ""}
          placeholder={placeholder}
          onKeyUp={async (e) => {
            if (e.key === "Enter" && onEnter)
              await onEnter?.(e, e.currentTarget.value);
          }}
          onChange={(e) => {
            let newValue = e.target.value || "";
            setLocalValue(newValue);
            debounce(
              "searchDebounce",
              () => {
                onChange?.(newValue?.trim());
              },
              500
            );
          }}
        />
      </div>
    </AiDescription>
  );
}
